module.exports = __webpack_public_path__ + "static/img/telephone-charge.b95c36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/telephone-charge.png
// module id = Y5lK
// module chunks = 1